/**
 * Status badge color classes (Tailwind).
 */
export const SESSION_STATUS_COLORS: Record<string, string> = {
  pending: "bg-gray-100 text-gray-800",
  loading: "bg-blue-100 text-blue-800",
  active: "bg-green-100 text-green-800",
  completed: "bg-gray-100 text-gray-600",
  cancelled: "bg-red-100 text-red-800",
};

export const SIMULATOR_STATUS_COLORS: Record<string, string> = {
  idle: "bg-gray-100 text-gray-800",
  running: "bg-orange-100 text-orange-800",
  loading: "bg-blue-100 text-blue-800",
  "in-session": "bg-green-100 text-green-800",
  offline: "bg-red-100 text-red-800",
  errored: "bg-red-100 text-red-800",
};

export const QUEUE_STATUS_COLORS: Record<string, string> = {
  waiting: "bg-yellow-100 text-yellow-800",
  "in-session": "bg-green-100 text-green-800",
  completed: "bg-gray-100 text-gray-600",
  removed: "bg-red-100 text-red-800",
};

/**
 * Human-readable labels.
 */
export const SESSION_STATUS_LABELS: Record<string, string> = {
  pending: "Pending",
  loading: "Loading",
  active: "Active",
  completed: "Completed",
  cancelled: "Cancelled",
};

export const SIMULATOR_STATUS_LABELS: Record<string, string> = {
  idle: "Idle",
  running: "Running",
  loading: "Loading",
  "in-session": "In Session",
  offline: "Offline",
  errored: "Error",
};

export const QUEUE_STATUS_LABELS: Record<string, string> = {
  waiting: "Waiting",
  "in-session": "In Session",
  completed: "Completed",
  removed: "Removed",
};

export { GAME_LABELS } from "@vms/types";

export const MODE_LABELS: Record<string, string> = {
  hotlap: "Hotlap",
  race: "Race",
};

export const MODE_COLORS: Record<string, string> = {
  hotlap: "bg-purple-100 text-purple-800",
  race: "bg-orange-100 text-orange-800",
};

export const SERVER_STATUS_COLORS: Record<string, string> = {
  online: "bg-green-100 text-green-800",
  offline: "bg-red-100 text-red-800",
  starting: "bg-blue-100 text-blue-800",
  stopping: "bg-yellow-100 text-yellow-800",
  errored: "bg-red-100 text-red-800",
  configuring: "bg-blue-100 text-blue-800",
};

export const SERVER_STATUS_LABELS: Record<string, string> = {
  online: "Online",
  offline: "Offline",
  starting: "Starting",
  stopping: "Stopping",
  errored: "Error",
  configuring: "Configuring",
};

export const SERVER_SESSION_TYPE_LABELS: Record<string, string> = {
  practice: "Practice",
  qualify: "Qualifying",
  race: "Race",
  booking: "Booking",
  loading: "Loading",
};

export const SERVER_SESSION_TYPE_COLORS: Record<string, string> = {
  practice: "bg-blue-100 text-blue-800",
  qualify: "bg-purple-100 text-purple-800",
  race: "bg-orange-100 text-orange-800",
  booking: "bg-gray-100 text-gray-700",
  loading: "bg-yellow-100 text-yellow-800",
};

export const EVENT_STATUS_COLORS: Record<string, string> = {
  draft: "bg-gray-100 text-gray-800",
  active: "bg-green-100 text-green-800",
  completed: "bg-blue-100 text-blue-800",
  deleted: "bg-red-100 text-red-800",
};

export const EVENT_STATUS_LABELS: Record<string, string> = {
  draft: "Draft",
  active: "Active",
  completed: "Completed",
  deleted: "Deleted",
};
